import React from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useForm ,Controller} from "react-hook-form";
import Axios from "axios";
import { useState,useEffect } from 'react';
import defaultimg from "../../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import { AddBenchCandidatesProfile,GetCountries,GetCourseInfo,GetJobRoles,GetListOfVendorsByEmployeeID,GetDocumentTypes, GetJobPosts, usStates, usStateCities,IndiaStates,IndiaStateCities, SaveCandidateRecordedAudio } from "../../apiconstants/constants";
import Swal from 'sweetalert2';
import LoadingSpinner from "../../helpers/loadingspinner";
import "../../consultant/addeditcandidate/cadidatestyles.css"
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import { Link, useNavigate } from "react-router-dom";
import Select from 'react-select';
import { useCountry } from "../../contexts/countrycodecontext.js";
import Modal from 'react-bootstrap/Modal';
import mammoth from "mammoth";

const AddCandidate = ()=>{

    const { register, handleSubmit,formState,reset,control,setValue,watch} = useForm();
    const { errors } = formState
    const navigate = useNavigate();
    const { isSubmitting } = formState;
    const [isDisabled, setIsDisabled] = useState(false);
    const [Courses,SetCourses]=useState([{}]);
    const [jobRoles,SetJobRoles]=useState([{}]);
    const [Countries,SetCountries]=useState([{}]);
    const [file, setFile] = useState();
    const[fileName,setFileName] = useState(null);
    const {selectedCountry} = useCountry();
    const [isLoading, setIsLoading] = useState(false);
    const [photoURL, setPhotoURL] = useState(null);
    const [visaCopy, setVisaCopy] = useState();
    const[visaCopyName,setVisaCopyName] = useState(null);
    const [drivingLicence, setDrivingLicence] = useState();
    const[drivingLicenceName,setDrivingLicenceName] = useState(null);
    const [maskedResumeCopy, setMaskedResumeCopy] = useState();
    const[maskedResumeName,setMaskedResumeName] = useState(null);
    const [imgfile, setimgFile] = useState();
    const [consultantDet,setConsultantDet] = useState([{}])
    const [vendorData, setVendorData] = useState([]);
    const [workmode,setWorkMode] = useState([
      {statusID:"1",statusName:"Work from Home"},
      {statusID:"2",statusName:"Work from Office"},
      {statusID:"3",statusName:"Hybrid"}]);
      const [candidateType,setCandidateType] = useState([
      {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
      {candidateTypeID:"C2C",typeName:"C2C"},
      {candidateTypeID:"W2",typeName:"W2"},
    {candidateTypeID:"1099",typeName:"1099"}]);
      const [preferLocation, setPreferLocation] = useState('');
      const billRatePlaceholder = selectedCountry == 1 ? 'Expected CTC' : 'Bill Rate';
      const payRatePlaceholder = selectedCountry == 1 ? ' Current CTC' : 'Pay Rate';
  const [documents,SetDocuments] =useState([{}]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState(null);
  const [jobPosts, setJobPosts] = useState([]);
const [showAssessmentModal, setShowAssessmentModal] = useState(false);
const [assessmentMode, setAssessmentMode] = useState(""); // "link" or "file"
const [assessmentFile, setAssessmentFile] = useState(null);
const documentLabels = {
  FileUrl: "Resume",
  // VisaCopyUrl: "VisaCopy",
  // DrivingLicenceUrl: "DrivingLicence",
  // PassportURL: "Passport",
  // I94File: "I-94",
  // RTR_PDFDoc:"RTR_PDF",
  // Resume_Insights_Pdfdoc:"Resume_Insights_Pdf",
  // OthersDoc:"Others"
};
const [showModal1, setShowModal1] = useState(false);
const [modalContent, setModalContent] = useState({
  title: '',
  url: '',
});
const workAuthOptions = [
  { value: "", label: "Current Visa" },

  // Citizenship / Permanent
  { value: "US Citizen", label: "US Citizen" },
  { value: "Green Card", label: "Green Card" },
  { value: "GC EAD", label: "GC EAD" },
  // H Visa
  { value: "H1B", label: "H1B" },
  { value: "H4 EAD", label: "H4 EAD" },

  // L Visa
  { value: "L1", label: "L1" },
  { value: "L2 EAD", label: "L2 EAD" },

  // F Visa
  { value: "OPT", label: "OPT (F1)" },
  { value: "OPT EAD", label: "OPT EAD" },
  { value: "CPT", label: "CPT (F1)" },

  // Trade / NAFTA
  { value: "TN Visa", label: "TN Visa" },
  { value: "E3", label: "E3 (Australia)" },

  // Employment Authorization
  { value: "EAD", label: "EAD (General Work Authorization)" },
  { value: "Asylum EAD", label: "Asylum EAD" },
  { value: "Refugee EAD", label: "Refugee EAD" },
  // Fallback
  { value: "Other", label: "Other" },
];


// Entry Visa options
const entryVisaOptions = [
  { value: "", label: "First Entry Visa" },
  { value: "B1/B2", label: "B1/B2 (Visitor)" },
  { value: "F1", label: "F1 (Student)" },
  { value: "H1B", label: "H1B" },
  { value: "H4", label: "H4" },
  { value: "J1", label: "J1 (Exchange Visitor)" },
  { value: "L1", label: "L1" },
  { value: "L2", label: "L2" },
  { value: "Other", label: "Other" },
];
 
// Alphabetical sort (ignores first "placeholder" option)
const sortOptions = (options) => {
  const [first, ...rest] = options;
  return [first, ...rest.sort((a, b) => a.label.localeCompare(b.label))];
};
  const [years, setYears] = useState("");
  const [months, setMonths] = useState("");
  const handleExperienceChange = (y, m) => {
    setYears(y);
    setMonths(m);
    const expText = `${y ? y + " Years" : ""} ${m ? m + " Months" : ""}`.trim();
    setValue("experience", expText); // store combined value in RHF
  };

const [workAuth, setWorkAuth] = useState("");
const [entryDate, setEntryDate] = useState("");
const [entryVisa, setEntryVisa] = useState("");

const handleWorkAuthChange = (auth, date, visa) => { 
  setWorkAuth(auth);
  setEntryDate(date);
  setEntryVisa(visa);

  let text = auth || "";

  const parts = [];
  if (visa) parts.push(visa);
  if (date) parts.push(`on ${date}`);

  if (parts.length > 0) {
    text = `${auth} (First US Entry: ${parts.join(" ")})`;
  }

  setValue("WorkAuthorizationandValidity", text);
};



const handleShowModal = (docType) => {
  setSelectedDocType(docType);
  setShowModal(true);
};
const handleCloseModal = () => {
  setShowModal(false);
  setSelectedDocType(null);
};
const handleShowModal1 = async (docTypeKey, file) => {
  if (!file) return;

  const fileName = file.name.toLowerCase();

  if (fileName.endsWith(".docx")) {
    // convert DOCX to HTML
    try {
      const arrayBuffer = await file.arrayBuffer();
      const { value } = await mammoth.convertToHtml({ arrayBuffer });
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: value,
        url: null,
        file: file,
      });
    } catch (error) {
      console.error("DOCX preview error", error);
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: "<p>Failed to render DOCX preview.</p>",
        url: null,
        file: file,
      });
    }
  } else {
    const blobUrl = URL.createObjectURL(file);
    setModalContent({
      title: documentLabels[docTypeKey] || docTypeKey,
      url: blobUrl,
      html: null,
      file: file,
    });
  }

  setShowModal1(true);
};
const handleCloseModal1 = () => {
  setShowModal1(false);
};
const renderAttachment = (url, file, html) => {
  if (html) {
    // DOCX preview via mammoth
    return (
      <div
        style={{ maxHeight: "500px", overflowY: "auto" }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  if (!file) {
    return <div>File not found.</div>;
  }

  const name = file.name?.toLowerCase() || "";

  if (name.endsWith(".pdf")) {
    return (
      <iframe
        src={url}
        style={{ width: "100%", height: "500px", border: "none" }}
        title="PDF Preview"
      />
    );
  }  else if (name.match(/\.(jpg|jpeg|png)$/)) {
    return (
      <div style={{ textAlign: "center" }}>
        <img
          src={url}
          alt="Image Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "500px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        />
        <div style={{ marginTop: "10px" }}>
          <a
            href={url}
            download={name.replace(/^[0-9a-fA-F-]+_/, "")} // clean name
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#007bff",
              fontWeight: "500",
            }}
          >
            ⬇️ Download Image
          </a>
        </div>
      </div>
    );
  }  else if (name.endsWith(".html") ||
    name.endsWith(".htm")) {
            return (
                <iframe
                    src={url}
                    title="HTML Attachment"
                    style={{ width: '100%', height: '500px', border: 'none' }}
                />
            );
        } else {
    return (
      <div>
        <p style={{ fontSize: 14 }}>
          Preview is not supported for this file type. Please
          <a href={url} download={file.name} style={{ marginLeft: 5 }}>
            download
          </a>
          .
        </p>
      </div>
    );
  }
};
const handleRemoveFile = (docTypeKey) => {
  const updatedFiles = { ...uploadedFiles };
  delete updatedFiles[docTypeKey];
  setUploadedFiles(updatedFiles);
};

const selectedJobRole = watch("JobRole");
const selectedVendorGuid = watch("VendorGuid");
useEffect(() => {
  if (selectedJobRole && selectedVendorGuid) {
    fetchJobPosts(parseInt(selectedJobRole), selectedVendorGuid);
  } else {
    setJobPosts([]); // clear if either is not selected
  }
}, [selectedJobRole, selectedVendorGuid]);

const fetchJobPosts = async (jobRoleId, vendorGuid) => {
  setIsLoading(true);
  try {
    const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
// Filter based on selected Job Role and Vendor (client)
    const filteredPosts = response.data.filter((post) =>
      post.jobRoleID == jobRoleId && post.vGuid == vendorGuid&&
       post.status=="Active"
    );
        console.log(filteredPosts)

    setJobPosts(filteredPosts);
  } catch (error) {
    console.error("Error fetching job posts", error);
  } finally {
    setIsLoading(false);
  }
};



const fetchcoursesdata=()=>
    {
      const GetapiUrl=GetCourseInfo.APIURL;
      const fetchJSON = async () => {
        const response = await fetch(GetapiUrl);
        let json = await response.json();
        SetCourses(json);
       setValue("QualificationID",3)
       setValue("workMode","Hybrid")
       setValue("clientStatus","New")
      setValue("CandidateType","C2C")
      }
      fetchJSON();
}

const GetVendorsList = () => {
  setIsLoading(true);

  const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

  Axios.get(GetapiUrl)
    .then((result) => {
      setIsLoading(false);

      setVendorData(result.data);
    }).catch((error) => {
      console.log("Error" + error);
    });
};

const fetchcountries = () => {
  const GetapiUrl = GetCountries.APIURL;
  const token = localStorage.getItem("jwtToken"); // or wherever you store the token

  const fetchJSON = async () => {
    const response = await fetch(GetapiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`  // 👈 Authorization added
      }
    });

    let json = await response.json();
    SetCountries(json);
  };

  fetchJSON();
};


let Guid="";

const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")
const email = localStorage.getItem("email")
const token = localStorage.getItem('jwtToken');
const roleID = localStorage.getItem("roleID")

if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}

const FetchJobroles=()=>
  {
    const GetapiUrl= `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`; 
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl);
      let json = await response.json();
      SetJobRoles(json);
    }
    fetchJSON();
}

const jobPostOptions = jobPosts.map(job => ({
        label: job.title,
        value: job.jobPostID,
        jobDescription: job.jobDescription // Store job description for later use
      }));

const handleImageUpload = async (event) => {
  const file = event.target.files[0];
  setPhotoURL(file)
  setimgFile(URL.createObjectURL(file));
  var fileInput =document.getElementById('photo');
var filePath = fileInput.value;
       
// Allowing file type
var allowedExtensions =
      /(\.jpg|\.jpeg|\.png)$/i;

if (!allowedExtensions.exec(filePath)) {
Swal.fire({
  text: 'Invalid File Type!',
    })
 // toast.error('Issue with data format', {autoClose:500})
 
  fileInput.value = '';
  setimgFile("");
  
  return false;
}
else
{ 
setimgFile(URL.createObjectURL(event.target.files[0]));
return true;
} 

}

const saveCandidateAudio = async (candidateGuid, candidateName, audioFile) => {
  const audioFormData = new FormData();
  audioFormData.append("Guid", candidateGuid || null);
  audioFormData.append("CandidateName", candidateName || null);
  audioFormData.append("Audio", audioFile);
  audioFormData.append("AudioUrl", audioFile.name);
  audioFormData.append("FileId", "");

  try {
    await Axios.post(SaveCandidateRecordedAudio.APIURL, audioFormData, {
      headers: { "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`
       },
    });
  } catch (error) {
    console.error("Audio upload failed", error);
  }
};


const onSubmit = (data,e) => {
        e.preventDefault();
       if (!uploadedFiles.FileUrl) {
    Swal.fire({
      icon: "error",
      title: "Resume is required",
      text: "Please upload a Resume before submitting",
    });
          return;
        }
        setIsLoading(true);
      
       AddData(data)
    
    }
 const AddData= async(data)=>{
      // console.log(data.BillRate)
      const formData = new FormData();
      const response = await fetch(defaultimg);
      const imageBlob = await  response.blob();
       // Build Address from state + city
const address =`${selectedState} - ${selectedCity}`
    console.log(address)



       formData.append('UserGuid', Guid);
       formData.append("Address", address);
      formData.append('ProfileSummery', data.ProfileSummery);
      formData.append('Gender', data.gender);
      formData.append('MaritalStatus', data.maritalStatus);
    //  formData.append('ConsultantID',consultantDet[0].consultantID);
      formData.append('QualificationID', data.QualificationID);
      formData.append('Experience', data.experience);
      formData.append('MobileNumber', data.mobileNumber);
      formData.append('CurrentRole', "string");
      formData.append('MarketingStatus', "Active");
      formData.append('CandidateType', data.CandidateType);
      formData.append('JobTitleID', data.jobPost ? data.jobPost?.value : "");
  // Resume string + file
formData.append(
  "Resume",
  uploadedFiles.FileUrl ? uploadedFiles.FileUrl.name : null
);
formData.append("FileUrl", uploadedFiles.FileUrl || null);

// VisaCopy string + file
formData.append(
  "VisaCopy",
  uploadedFiles.VisaCopyUrl ? uploadedFiles.VisaCopyUrl.name : null
);
formData.append("VisaCopyUrl", uploadedFiles.VisaCopyUrl || null);

// DrivingLicence string + file
formData.append(
  "DrivingLicence",
  uploadedFiles.DrivingLicenceUrl ? uploadedFiles.DrivingLicenceUrl.name : null
);
formData.append("DrivingLicenceUrl", uploadedFiles.DrivingLicenceUrl || null);

// Passport string + file
formData.append(
  "Passport",
  uploadedFiles.PassportURL ? uploadedFiles.PassportURL.name : null
);
formData.append("PassportURL", uploadedFiles.PassportURL || null);

// I94 string + file
formData.append(
  "I94",
  uploadedFiles.I94File ? uploadedFiles.I94File.name : null
);
formData.append("I94File", uploadedFiles.I94File || null);

// RTR PDF + file
formData.append(
  "RTR_PDF",
  uploadedFiles.RTR_PDFDoc ? uploadedFiles.RTR_PDFDoc.name : null
);
formData.append("RTR_PDFDoc", uploadedFiles.RTR_PDFDoc || null);
formData.append(
  "Resume_Insights_Pdf",
  uploadedFiles.Resume_Insights_Pdf ? uploadedFiles.Resume_Insights_Pdfdoc.name : null
);
formData.append("OthersDoc", uploadedFiles.OthersDoc || null);
formData.append(
  "Others",
  uploadedFiles.Others ? uploadedFiles.OthersDoc.name : null
);
formData.append("Resume_Insights_Pdfdoc", uploadedFiles.Resume_Insights_Pdfdoc || null);
      formData.append('HighestEducation', data.HighestEducation);
      formData.append ('Photo', data.photo);
      formData.append('PhotoURL', photoURL?photoURL:defaultimg);
      formData.append('WorkMode', data.workMode);
      formData.append('TechnicalSkill', data.technicalSkill);
      formData.append('DOB', data.dob);
      formData.append('FullName', data.fullName);
      formData.append('Email', data.email);
   formData.append(
  "PayRate",
  data.PayRate
    ? selectedCountry == 2
      ? `$${data.PayRate}`
      : `Rs.${data.PayRate}`
    : ""
);


formData.append("BillRate",  data.BillRate? selectedCountry == 2? `$${data.BillRate}`: `Rs.${data.BillRate}`
    : ""
);


      formData.append('WorkAuthorizationandValidity',  selectedCountry == 2 ? data.WorkAuthorizationandValidity : null);
      formData.append('EmployerName', data.EmployerName);
      formData.append('SSN', selectedCountry == 2 ? data.SSN : null );
      formData.append('PassportNo', selectedCountry == 2 ? data.PassportNo : null);
      formData.append('Tworefrencesfromrecentproject', data.Tworefrencesfromrecentproject);
      formData.append('Certifications', data.Certifications);
      formData.append('Comments', data.Comments);
      formData.append('Priority', data.Priority);
      formData.append('JobRole', data.JobRole);
      // formData.append('VisaCopy',data.VisaCopy  );
      // formData.append('VisaCopyUrl', visaCopy );
      formData.append('MaskedResume', data.MaskedResume);
      formData.append('MaskedFileUrl', maskedResumeCopy);
      // formData.append('DrivingLicence',data.DrivingLicence );
      // formData.append('DrivingLicenceUrl',drivingLicence   );
      formData.append('LinkedInUrl', data.LinkedInUrl);
      formData.append('AvailabilityToInterview', data.AvailabilityToInterview);
      formData.append('AvailabilityToJoin', data.AvailabilityToJoin);
      formData.append('WillingToRelocate', data.WillingToRelocate);
      formData.append('VendorGuid', '00000000-0000-0000-0000-000000000000');
      formData.append('clientStatus', data.clientStatus);
      formData.append('CreatedBy', email);    
      // const selectedCountry = parseInt(data.CountryMappings);
      formData.append("CountryID", selectedCountry);
      formData.append('PreferLocation', selectedCountry);
      formData.append('SubmittedBy', email);
      formData.append('CustomAssessmentLink',data.customAssessmentLink)
      formData.append('SkillMetrics',data.SkillMetrics)

      const apiAddUrl = AddBenchCandidatesProfile.APIURL;

       Axios.post(apiAddUrl,formData)
       .then(async (result)=>{
         setIsLoading(false)
          if (result.data.message === "Record created successfully") 
               { 
                  const newCandidateGuid = result.data.guid;
                    //alert("created");
                 Swal.fire({
                   position: 'center',
                   icon: 'success',
                   title: 'Submitted Successfully ',
                   showConfirmButton: false,
                   timer: 5000
                 })
              if (assessmentMode === "file" && assessmentFile) {
                await saveCandidateAudio(newCandidateGuid, data.fullName, assessmentFile);
              }
                 navigate("/Employer/GetCandidatesByEmployerUserID")
                    reset();         
               }
               else if (result.data.message===`This Candidate already registered with the ${data.email}`){
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: `This Candidate already registered with the ${data.email}`,
                  showConfirmButton: false,
                  timer: 7000
                })
               }
               else if(result.data.message === " Input data having some issues")
               { 
                 Swal.fire({
                   position: 'center',
                   icon: 'error',
                   title: 'Not Submitted',
                   showConfirmButton: false,
                   timer: 7000
                 })
                 
              // toast.error('Issue with data format', {autoClose:5000})
               }
               
       })
         .catch(()=>{
           setIsLoading(false)
           Swal.fire({
             position: 'center',
             icon: 'error',
             title: 'Something went wrong try again',
             showConfirmButton: false,
             timer: 7000
           })
         })
         }   
       
         const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription ,// Store job description for later use
        billRate: job.billRate,
      }));

 const [skills, setSkills] = useState([
    { Skill: "", YearsOfExp: "", Rating: "" },
  ]);

  // Handle input change
  const handleChange = (index, field, value) => {
    const updated = [...skills];
    updated[index][field] = value;
    setSkills(updated);

    // Keep API value updated as stringified JSON
    setValue("SkillMetrics", JSON.stringify(updated));
  };

  // Add new row
  const handleAdd = () => {
    setSkills([...skills, { Skill: "", YearsOfExp: "", Rating: "" }]);
  };

  // Delete row
  const handleDelete = (index) => {
    const updated = skills.filter((_, i) => i !== index);
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated));
  };
const [selectedState, setSelectedState] = useState("");
const [selectedCity, setSelectedCity] = useState("");
const [cities, setCities] = useState([]);

const handleStateChange = (stateValue) => {
  let cityList = [];

  if (selectedCountry == 1) {
    // India
    cityList = IndiaStateCities[stateValue] || [];
  } else {
    // US
    cityList = usStateCities[stateValue] || [];
  }

  setCities(cityList);
};

    useEffect(()=>{
      fetchcoursesdata();
      GetVendorsList();
      FetchJobroles();
      fetchcountries();
       setCities([]);
  setSelectedCity(""); 
  },[selectedCountry])
 return(
   <ConsultantLayout>
  <section>
  {
  isLoading ? <center> <LoadingSpinner /> </center> : 
  <div className="container-fluid mt-4 pb-5">
         <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/GetCandidatesByEmployerUserID">
    <i className="fa  fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Add Candidate</h2>
</div>

<hr/>
     <div className="bg-gray mt-4">
      
        <form onSubmit={handleSubmit(onSubmit)} id="loginform">
       
       <div class="row p-3">
<div className="col-sm-12 col-lg-2 col-xl-2 col-md-2">
<div className="upload-btn-wrapper text-center"> 
         
<label htmlFor="photo" style={{ cursor: 'pointer' }}>
        <img src={imgfile?imgfile: defaultimg} alt="Upload Image" style={{cursor:"pointer",  borderRadius: '50%',
            width: '100px',
            height: '100px',}} />
        <input
          type="file"
          id="photo"
          style={{ display: 'none' }}
          {...register('photo', { onChange: handleImageUpload })}
        />
       
      </label>
            

          </div>

</div>
<div className="col-sm-12 col-xl-5 col-lg-5 col-md-5">
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>  
          <input type="text" title='' placeholder='Full Name' {...register("fullName", { required: "Fullname Required" })} id="fullName" name="fullName" 
           disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.fullName ? 'is-invalid' : ''}`}
                      />
        </OverlayTrigger>
        <div className="invalid-feedback"> {errors.fullName?.message}</div>

        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>    
   
   <input 
                placeholder='Mobile Number'
                type="Number"
                min="0"
                title=''
                name="mobileNumber"
                disabled={isDisabled}
                {...register("mobileNumber", { required: "Mobile Number Required" })}
                className={`form-control basic-form mt-3 ${errors.mobileNumber ? 'is-invalid' : ''}`}
            />
      </OverlayTrigger>
      <div className="invalid-feedback"> {errors.mobileNumber?.message}</div>

      <div class="mb-2 mt-4" style={{fontSize:12, color:"#495057" }}>
          <label >Gender</label>

          </div>
          <input 
        {...register("gender", { required: true })}
        type="radio"
        name="gender"
        value="Male"
        id="field-male"
        disabled={isDisabled}
         defaultChecked
      /> 
      <label style={{ fontSize: 13, color: "#495057", marginRight:'30px',marginLeft:'10px' }}>Male</label>
      
      <input  
        {...register("gender", { required: true })}
        type="radio"
        name="gender"
        value="Female"
        id="field-female"
        disabled={isDisabled}
      />
      <label style={{ fontSize: 13, color: "#495057", marginLeft: 10 }}>Female</label>
      
      {errors.gender && <div style={{color:"#dc3545",fontSize:"80%"}}>Gender required</div>}
      
    
            

<div class="mb-2 mt-4" style={{fontSize:12, color:"#495057"}}>
          <lable >Marital Status</lable>
          </div>
        <input
                     {...register("maritalStatus")}
                     type="radio"
                     name="optionalField"
                     title='maritalStatus'
                     value="married"
                     id="maritalStatus"
                     disabled={isDisabled}
                     className="mr-2"
                     defaultChecked
                 /><label style={{fontSize : 13,color:"#495057"}}>Married</label>
                  &nbsp;&nbsp;
                  <input 
                     {...register("maritalStatus")}
                     type="radio"
                     name="optionalField"
                     title='maritalStatus'
                     value="unmarried"
                     id="field-female"
                     
                     disabled={isDisabled}
                 /><label style={{fontSize : 13, color:"#495057", marginLeft : 10}}>Unmarried</label>

             
                     <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Education</Tooltip>)}>    

<select  {...register("QualificationID", { required: "Education Required" })} className={`form-control mt-3 ${errors.QualificationID ? 'is-invalid' : ''}`}style={{height:50 ,borderRadius:15,fontSize:12}}  >
<option value="">Select Education</option>
{
  Courses.map((item,index)=>
  {
    return(

   <option key={index}  value={item.qualificationID}>{item.courseName}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.QualificationID?.message}</div>
   <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Highest Education</Tooltip>)}>  
                      <input type="text" title='' placeholder='Highest Education' {...register("HighestEducation")} id="HighestEducation" name="HighestEducation" 
                      disabled={isDisabled} className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>

    
   {selectedCountry == 2 && (
  <div className="d-flex gap-2 mt-3">

    {/* Current Visa */}
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip-workauth">Current Visa</Tooltip>}
    >
      <select
        className="form-control"
        style={{ height: 50 }}
        value={workAuth}
        onChange={(e) => handleWorkAuthChange(e.target.value, entryDate, entryVisa)}
      >
        {sortOptions(workAuthOptions).map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </OverlayTrigger>

    {/* First US Entry Visa */}
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip-entry-visa">First US Entry Visa Type</Tooltip>}
    >
      <select
        className="form-control"
        style={{ height: 50 }}
        value={entryVisa}
        onChange={(e) =>
          handleWorkAuthChange(workAuth, entryDate, e.target.value)
        }
      >
        {sortOptions(entryVisaOptions).map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </OverlayTrigger>

    {/* First US Entry Date */}
    <OverlayTrigger
  placement="bottom"
  overlay={<Tooltip id="tooltip-year">First US Entry Year</Tooltip>}
>
  <select
    className="form-control"
    style={{ height: "50px" }}
    value={entryDate}
    onChange={(e) => handleWorkAuthChange(workAuth, e.target.value, entryVisa)}
  >
    <option value="">Select Year</option>
    {Array.from({ length: new Date().getFullYear() - 1969 }, (_, i) => {
      const year = new Date().getFullYear() - i;
      return (
        <option key={year} value={year}>
          {year}
        </option>
      );
    })}
  </select>
</OverlayTrigger>
 

    <input
      type="hidden"
      {...register("WorkAuthorizationandValidity")}
    />
  </div>
)}

                  <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> EmployerName</Tooltip>)}>  
                    <input type="text" title='' placeholder='Employer Name' {...register("EmployerName")} id="EmployerName" name="EmployerName" 
                    disabled={isDisabled} className={`form-control basic-form mt-3`}
                                />
                  </OverlayTrigger>
               {selectedCountry == 2 &&  ( <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> SSN</Tooltip>)}>    
            
                  <input 
                  placeholder='Enter last 4 digits of SSN'
                  type="number"
                  name="SSN"
                  {...register("SSN", { 
                    validate: value => {
                      // Check if value is empty
                      if (!value) return true;
                      // Check if value is exactly 4 digits
                      const valueStr = value.toString();
                      if (valueStr.length !== 4) {
                        return "SSN must be exactly 4 digits";
                      }
                      return true;
                    }
                  })}
                  className={`form-control basic-form mt-3`}
                  onInput={(e) => {
                    if (e.target.value.length > 4) {
                      e.target.value = e.target.value.slice(0, 4);
                    }
                  }}
                />
                  </OverlayTrigger>)}
      
                  {selectedCountry == 2 &&  (    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Passport Number</Tooltip>)}>  
                      <input type="text" title=''  name="optionalField" placeholder='Passport Number' {...register("PassportNo")} id="PassportNo"  
                      className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>)}
      
               
                      <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Job Role</Tooltip>)}>    

<select  {...register("JobRole", { required: "Job Role Required" })} className={`form-control mt-3 ${errors.JobRole ? 'is-invalid' : ''}`} style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Job Role</option>
{
  jobRoles.map((item,index)=>
  {
    return(

   <option key={index}  value={item.jobRoleId}>{item.jobRole}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.JobRole?.message}</div>
{/* <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Candidate Type
</Tooltip>)}>
<select  {...register("CandidateType")} className={`form-control mt-3`}style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Candidate Type</option>
{
  candidateType.map((item,index)=>
  {
    return(

   <option key={index}  value={item.candidateTypeID}>{item.candidateTypeID}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>   */}
   <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Certifications</Tooltip>)}>  
                      <input type="text" title='' placeholder='Certifications' {...register("Certifications")} id="Certifications" name="Certifications" 
                      disabled={isDisabled} className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>
  
</div>


  



<div  className="col-sm-12 col-xl-5 col-lg-5 col-md-5">




<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}> 
          <input type="text"  placeholder='Email' id="email" name="email" {...register("email" , { required: "Email Required" })} 
           disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.email ? 'is-invalid' : ''}`}

          />
          </OverlayTrigger>
          <div className="invalid-feedback"> {errors.email?.message}</div>

          <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Date of Birth</Tooltip>)}>
        <input type="date" pattern="/^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/"   name="dob"
         {...register("dob")}
         className={`form-control basic-form mt-3 `} placeholder="Date of birth" aria-label="Username"/>
        </OverlayTrigger>
 <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Summary</Tooltip>)}>  
          <textarea type="text" style={{height:100}} title='' placeholder='Profile Summary' {...register("ProfileSummery")} id="ProfileSummery" name="ProfileSummery" 
           disabled={isDisabled} className={`form-control basic-form mt-3 `}
                      />
        </OverlayTrigger>

 <div className="d-flex gap-2 mt-3">
  {/* State Dropdown */}
  <select
  name="state"
  className="form-control mt-3"
  value={selectedState}   // <-- bind to state
  onChange={(e) => {
    setSelectedState(e.target.value);   // <-- update state
    handleStateChange(e.target.value);  // <-- still trigger city fetch
  }}
>
  <option value="">Select State</option>
  {selectedCountry == 1
    ? IndiaStates.map((s) => (
        <option key={s.value} value={s.value}>
          {s.label}
        </option>
      ))
    : usStates.map((s) => (
        <option key={s.value} value={s.value}>
          {s.label}
        </option>
      ))}
</select>

  {/* City Dropdown */}
  <select
  name="city"
  className="form-control mt-3"
  value={selectedCity}
  onChange={(e) => setSelectedCity(e.target.value)}
  disabled={cities.length === 0}
>
  <option value="">Select City</option>
  {cities
    .slice() // make a copy to avoid mutating state
    .sort((a, b) => a.localeCompare(b)) // sort alphabetically
    .map((city, i) => (
      <option key={i} value={city}>
        {city}
      </option>
    ))}
</select>


</div>




           <div className="d-flex gap-2 mt-3">
  {/* Years Dropdown */}
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-years">Years of Experience</Tooltip>}
  >
    <select
      className={`form-control ${errors.experience ? "is-invalid" : ""}`}
      value={years}
      style={{height:50}}
      onChange={(e) => handleExperienceChange(e.target.value, months)}
    >
      <option value="">Years</option>
      {[...Array(51).keys()].map((y) => (
        <option key={y} value={y}>{y}</option>
      ))}
    </select>
  </OverlayTrigger>

  {/* Months Dropdown */}
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-months">Months of Experience</Tooltip>}
  >
    <select
      className={`form-control ${errors.experience ? "is-invalid" : ""}`}
     style={{height:50}}
      value={months}
      onChange={(e) => handleExperienceChange(years, e.target.value)}
    >
      <option value="">Months</option>
      {[...Array(12).keys()].map((m) => (
        <option key={m} value={m}>{m}</option>
      ))}
    </select>
  </OverlayTrigger>
</div>


      {/* Hidden field to actually store combined value */}
      <input
        type="hidden"
        {...register("experience", { required: "Experience Required" })}
      />

      <div className="invalid-feedback">{errors.experience?.message}</div>
            
                     
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Key Skills</Tooltip>)}> 
<div>
<textarea type="text" style={{height:100}} id="technicalSkill" name="technicalSkill" {...register("technicalSkill", { required: "KeySkills Required" })} placeholder="Enter Key Skills " className={`form-control basic-form mt-3 ${errors.technicalSkill ? 'is-invalid' : ''}`} />

</div>
</OverlayTrigger> 

<div className="invalid-feedback"> {errors.technicalSkill?.message}</div>

            <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Priority</Tooltip>)}> 
      <input type="text" name="Priority" {...register("Priority")} value={1} placeholder="Priority " 
      className={`form-control basic-form mt-3 `} />
      </OverlayTrigger>
     
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>LinkedIn Url</Tooltip>)}>  
          <input type="text" title='' placeholder='LinkedIn Url' {...register("LinkedInUrl")} id="LinkedInUrl" name="LinkedInUrl" 
           className={`form-control basic-form mt-3 `}/>
        </OverlayTrigger>         
  
        
    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Upload Documents
</Tooltip>)}>
<select 
  onChange={(e) => {
    setSelectedDocType(e.target.value);

    handleShowModal(e.target.value);  // open modal
     e.target.value ="";
  }}
className={`form-control mt-3 `}style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Any Document</option>

      <option value="Resume"> Resume </option>
</select>
                     </OverlayTrigger>
                    
                   <div>
 {Object.keys(uploadedFiles).map((docTypeKey) => {
  const file = uploadedFiles[docTypeKey];
  const displayLabel = documentLabels[docTypeKey] || docTypeKey; // fallback
  return (
 <div key={docTypeKey}>
  <strong style={{ fontSize: 12 }}>{displayLabel} :</strong> &nbsp;
  <span style={{ fontSize: 12 }}>{file.name}</span>
  &nbsp; | &nbsp;
  <button
  type="button"
  style={{
    border: "none",
    background: "transparent",
    color: "blue",
    fontSize: 12,
    cursor: "pointer"
  }}
  onClick={() => handleShowModal1(docTypeKey, file)}
>
  View
</button>
  &nbsp; | &nbsp;
  <button
    type="button"
    style={{
      border: "none",
      background: "transparent",
      color: "red",
      fontSize: 12,
      cursor: "pointer"
    }}
    onClick={() => handleRemoveFile(docTypeKey)}
  >
    Remove
  </button>
  
</div>

  );
})}


              </div>

</div>


</div>

 
 <div class="row mb-4 mt-3 ">
    <div class="col-12">  
    
            
               </div>
               </div>
               <Link to="/Employer/GetCandidatesByEmployerUserID"> 
                <button  style={{float:"right"}}  disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                  Cancel
                </button>
                </Link>
       <button id="svbutton" style={{float:"right"}} disabled={isSubmitting || isDisabled } className="btn btn-primary pf-save mb-3 mr-3" >
                     {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                     Save
                 </button> &nbsp;&nbsp;&nbsp;
     
     </form>
    

   </div>

</div>

 }

<Modal show={showModal} onHide={handleCloseModal}>
  <Modal.Header closeButton>
    <Modal.Title style={{color:"#00a7ac"}}>Upload {selectedDocType}</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{height:100}}>
    <input type="file" accept=".pdf,.jpg,.jpeg,.png,.docx" 

      style={{fontSize:18,color:"#00a7ac"}}
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        const originalFileName = file.name;
        // replace special characters
        const sanitizedFileName = originalFileName.replace(/[^a-zA-Z0-9.\-_]/g, "_");

        // allow only PDF, DOC, DOCX
        const allowedExtensions = /\.(pdf|doc|docx|jpg|jpeg|png|html)$/i;
        if (!allowedExtensions.test(sanitizedFileName)) {
          Swal.fire({
            icon: "error",
            text: "Invalid file type. Only PDF, DOC, or DOCX allowed.",
          });
          e.target.value = "";
          return;
        }

        // create new file with sanitized name
        const renamedFile = new File([file], sanitizedFileName, { type: file.type });

        let fileField = "";
        switch (selectedDocType) {
          case "Resume":
            fileField = "FileUrl";
            break;
          case "Visa Copy":
            fileField = "VisaCopyUrl";
            break;
          case "Driving Licence":
            fileField = "DrivingLicenceUrl";
            break;
          case "Passport":
            fileField = "PassportURL";
            break;
          case "I-94":
            fileField = "I94File";
            break;
              case "RTR_PDF":
            fileField = "RTR_PDFDoc";
            break;
             case "Resume_Insights_Pdf":
            fileField = "Resume_Insights_Pdfdoc";
            break;
             case "Others":
            fileField = "OthersDoc";
            break;
          default:
            fileField = `${selectedDocType}Url`;
        }

        setUploadedFiles((prev) => ({
          ...prev,
          [fileField]: renamedFile,
        }));

        handleCloseModal();
        setSelectedDocType("");
      }}
    />
  </Modal.Body>
</Modal>
<Modal show={showModal1} onHide={handleCloseModal1} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>{modalContent.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {renderAttachment(modalContent.url, modalContent.file, modalContent.html)}
  </Modal.Body>
</Modal>
<Modal show={showAssessmentModal} onHide={() => setShowAssessmentModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Custom Assessment Link</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {!assessmentMode && (
      <div className="d-flex flex-column gap-3">
        <button className="btn btn-outline-primary" onClick={() => setAssessmentMode("link")}>
          Enter Link Directly
        </button>
        <button className="btn btn-outline-secondary" onClick={() => setAssessmentMode("file")}>
          Upload File
        </button>
      </div>
    )}

    {assessmentMode === "link" && (
      <input
        type="text"
        className="form-control"
        placeholder="Enter Custom Assessment Link"
        {...register("customAssessmentLink")}
      />
    )}

    {assessmentMode === "file" && (
      <input
        type="file"
        accept="audio/*,.pdf,.doc,.docx,video/mp4,video/webm"
        className="form-control"
        onChange={(e) => setAssessmentFile(e.target.files[0])}
      />
    )}
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-secondary" onClick={() => {
      setAssessmentMode("");
      setShowAssessmentModal(false);
    }}>
      Close
    </button>
    <button className="btn btn-primary" onClick={() => setShowAssessmentModal(false)}>
      Done
    </button>
  </Modal.Footer>
</Modal>



 </section>
</ConsultantLayout>

    )
}
export default AddCandidate;